import { Component, OnInit, Input} from '@angular/core';
import { GlobalService } from '../../../global.service';

@Component({
  selector: 'app-usage-info',
  templateUrl: './usage-info.component.html',
  styleUrls: ['./usage-info.component.sass']
})
export class UsageInfoComponent implements OnInit {
  @Input() minutesUsageField;
  @Input() lDIUsageField;
  @Input() lDUsageField;
  @Input() sMSUSageField;
  @Input() sMSPremiunUsageField;
  @Input() mMSUsageField;
  @Input() info;
  @Input() index;
  @Input() productType;
  @Input() typeAccount;
  public usage2: any;
  constructor(private global: GlobalService) { }
 

  ngOnInit() {
    ///prueba
    this.usage_info();
  }
  usage_info() {
    
    let counter1 = 0;
    let iDLocal: number = 0;
    let counter2 = 0;
    let percentage: number = 0;
    let counterPad = 0;
    let usage = '{';
    usage += '"subscribers":';
    usage += '[';
    
      counter2 = 0;
      counterPad = 0;
      if (counter1 > 0) { usage += ','; }
      usage += '{';
      usage += '"subscriber":';
      usage += '[';
      this.info[this.index].usageInfoField.dataOffersField.map(function (offers) {
        if (counter2 > 0) { usage += ','; }
        usage += '{';
        usage += '"offerGroup":"' + offers.offerGroupField + '",';
        usage += '"DPlanName":"' + offers.displayNameField + '",';
        usage += '"Quota":"' + offers.quotaField + '",';
        usage += '"DLocalTop":"' + offers.quotaTextField + '",';
        usage += '"iDLocal":"' + offers.usedField + '",';
        usage += '"iDLocalText":"' + offers.usedTextField + '",';
        if (parseFloat(offers.quotaField) > 0) {
          if (offers.usedField === null) {
            iDLocal = 0;
          }
          else {
            iDLocal = offers.usedField;
          }
          percentage = (iDLocal * 100) / parseFloat(offers.quotaField);
          percentage = parseInt(percentage.toString());
        }
        usage += '"percentage":' + percentage + ',';
        if (offers.offerGroupField.search('BASE') > -1) {
          usage += '"type":"PL-ACT"';
        }
        else if ((offers.offerGroupField.search("NT_ROAM_GRANEL"))||(offers.offerGroupField.search("NT_NOPURCHASESMS")) > -1) {
          usage += '"type":"DR"';
        }
        else {
          if (counterPad === 0) {
            usage += '"type":"PQ-AD"';
          }
          else {
            usage += '"type":""';
          }
          counterPad++;
        }
        usage += '}';
        counter2++;
      });
      usage += '],"countDR":' + counter2 + ',"countPQAD":' + counterPad + ',"productType":"' + this.info[this.index].productTypeField + '"';
      usage += '}';
      counter1++;
    
    usage += ']';
    usage += '}';
    this.usage2 = JSON.parse(usage).subscribers;
  }
  
  dataLoading(sw) {
    setTimeout(() => {
      this.global.loadCanvas();
    }, 2000);
  }
}
